import React from "react";

const VacancyContract = () => {
  return (
    <div>
      {/* PARAGRAPH 1 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 1 Mietsache</strong>
          </h3>
          <ol>
            <li>
              Der Vermieter vermietet dem Mieter vom{" "}
              <span className="mention-variable" data-variable-id="moveInDate">
                $MoveIn-Date
              </span>{" "}
              ab zu Wohnzwecken die Wohnung in der{" "}
              <span
                className="mention-variable"
                data-variable-id="objectAddress"
              >
                $Object-Address
              </span>
              ,{" "}
              <span className="mention-variable" data-variable-id="objectZip">
                $Object-Zip
              </span>{" "}
              <span className="mention-variable" data-variable-id="objectCity">
                $Object-City
              </span>
              ,{" "}
              <span className="mention-variable" data-variable-id="rentalUnitDisplayName">
                $RentalUnit-DisplayName
              </span>
              .<br />
            </li>
            <li style={{ textAlign: "justify" }}>
              <span style={{ color: "black" }}>
                Die Wohnfläche beträgt ca.{" "}
                <strong>
                  <span
                    className="mention-variable"
                    data-variable-id="rentalUnitArea"
                  >
                    $Rental-Unit-Area
                  </span>
                  m²
                </strong>
                . Diese Angabe dient wegen möglicher Messfehler nicht zur
                Festlegung des Mietgegenstandes. Der räumliche Umfang der
                gemieteten Sache ergibt sich vielmehr aus der Anzahl der
                gemieteten Räume.
              </span>
              <br />{" "}
            </li>
            <li style={{ textAlign: "justify" }}>
              <span style={{ color: "black" }}>
                Der tatsächliche Zustand der Mietsache im Zeitpunkt der Übergabe
                wird im Übergabeprotokoll niedergelegt.
              </span>
              <br />{" "}
            </li>
            <li style={{ textAlign: "justify" }}>
              <span style={{ color: "black" }}>
                Die in Abs. 1 bezeichnete Wohnung besteht aus:{" "}
                <span
                  className="mention-variable"
                  data-variable-id="rentalUnitRooms"
                >
                  $Rental-Unit-Rooms
                </span>{" "}
                Zimmern,{" "}
                <span
                  className="mention-variable"
                  data-variable-id="rentalUnitKitchen"
                >
                  $Rental-Unit-Kitchen
                </span>{" "}
                Küche,{" "}
                <span
                  className="mention-variable"
                  data-variable-id="rentalUnitBathrooms"
                >
                  $Rental-Unit-Bathrooms
                </span>{" "}
                Badezimmer,{" "}
                <span
                  className="mention-variable"
                  data-variable-id="rentalUnitHallway"
                >
                  $Rental-Unit-Hallway
                </span>{" "}
                Flur.
              </span>
            </li>
          </ol>
        </div>
      </>
      {/* PARAGRAPH 2 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 2 Ausschluss der Garantiehaftung</strong>
          </h3>
          <p style={{ textAlign: "justify" }}>
            Für Mängel, die bei Abschluss des Vertrages vorhanden sind, haftet
            der Vermieter nur, soweit er diese zu vertreten hat. Das Recht auf
            Minderung bleibt unberührt.
          </p>
          <p style={{ textAlign: "justify" }}>
            Dieser Haftungsausschluss findet keine Anwendung, soweit der
            Vermieter die Mangelfreiheit oder eine bestimmte Eigenschaft der
            Mietsache zugesichert oder den Mangel arglistig verschwiegen hat.
          </p>
        </div>
      </>
      {/* PARAGRAPH 3 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 3 Miete und Betriebskosten</strong>
          </h3>
          <div>
            <span style={{ color: "black" }}>
              1. Die Miete beträgt monatlich:
            </span>
            <figure className="table" style={{ width: "90.09%;" }}>
              <table className="ck-table-resized">
                <colgroup>
                  <col style={{ width: "95%;" }} />
                  <col style={{ width: "95%;" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td style={{ padding: "0.5rem 0;" }}>Grundmiete</td>
                    <td
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <span
                        className="mention-variable"
                        data-variable-id="rentalUnitRentBase"
                      >
                        $Rental-Unit-RentBase
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "0.5rem 0;" }}>
                      Nebenkosten-Vorauszahlaung
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <span
                        className="mention-variable"
                        data-variable-id="rentalUnitAdditionalCosts"
                      >
                        $Rental-Unit-RentAdditionalCosts
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ padding: "0.5rem 0;" }}>
                      <strong>Monatlich insgesamt zu zahlende Miete</strong>
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <strong>
                        <span
                          className="mention-variable"
                          data-variable-id="rentalUnitRentTotal"
                        >
                          $Rental-Unit-RentTotal
                        </span>
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </figure>
            <br />
            <div>
              2. Die Miete gemäß Abs. 1 ist monatlich im Voraus, spätestens bis
              zum dritten Werktag eines jeden Monats kostenfrei nach näherer
              Bestimmung des Vermieters zu entrichten.
            </div>
            <div>
              3. Der Vermieter ist berechtigt,
              <ol>
                <li style={{ textAlign: "justify" }}>
                  Gesetzlich zulässige Mieterhöhungen vorzunehmen,
                </li>
                <li style={{ textAlign: "justify" }}>
                  Unter Beachtung des Grundsatzes der Wirtschaftlichkeit für
                  zukünftige Abrechnungszeiträume zusätzliche zu den in Abs. 1b
                  in Verbindung mit Abs. 4 genannten Kosten auch solche
                  Betriebskosten im Sinne der Betriebskostenverordnung nach
                  billigem Ermessen auf den Mieter umzulegen und mit diesem
                  abzurechnen, die derzeit nicht anfallen, aber später entstehen
                  oder zukünftig vom Gesetzgeber neu eingeführt werden.
                </li>
              </ol>
              <p style={{ textAlign: "justify" }}>&nbsp;</p>
            </div>
            <div>
              4. Die Betriebskosten im Sinne der Betriebskostenverordnung werden
              vom Mieter getragen, und zwar wie folgt:
              <p>Monatliche Vorauszahlung für:</p>
              <ol>
                <li>Allgemeine Betriebskosten:</li>
              </ol>
              <ul>
                <li>Kosten der Beleuchtung</li>
                <li>Kosten der Dachrinnenreinigung</li>
                <li>Kosten der Gartenpflege</li>
                <li>Kosten der Gebäudereinigung und Ungezieferbekämpfung</li>
                <li>
                  Kosten der laufenden öffentlichen Lasten des Grundstücks
                </li>
                <li>Kosten der Messgebühr Schornsteinfeger</li>
                <li>
                  Kosten der privaten Verteilanlagen für Breitbandkabelnetze
                </li>
                <li>Kosten der Regenwassergebühren</li>
                <li>Kosten der Sach- und Haftpflichtversicherung</li>
                <li>Kosten der Schnee- und Glatteisbeseitigung</li>
                <li>Kosten der Schornsteinreinigung</li>
                <li>Kosten der Straßenreinigung und Müllbeseitigung</li>
                <li>
                  Kosten der Wartungs- und Reinigungskosten der Etagenheizung
                </li>
                <li>bzw. Warmwassergeräte</li>
                <li>Kosten der Wasserversorgung und Entwässerung</li>
                <li>Kosten des Hausmeisters/Hauswarts</li>
                <li>
                  Sonstige Betriebskosten (Kosten der
                  Warmwasseraufbereitung,&nbsp;
                </li>
                <li>
                  der Trinkwasserverordnung, der Wartung der Feuerlöscher,&nbsp;
                </li>
                <li>
                  der Wartung der Rauch- und Wärmeabzugsanlagen, der Wartung
                  der&nbsp;
                </li>
                <li>Rauchmelder, der Lüftungsanlage usw.)</li>
                <span
                  className="condition-variable"
                  data-condition-id="heatingCostsInclusive"
                >
                  <li>Heizkosten</li>
                </span>
                <li>Nutzerwechselgebühren</li>
              </ul>
            </div>
            <figure className="table" style={{ width: "90.09%;" }}>
              <table className="ck-table-resized">
                <colgroup>
                  <col style={{ width: "100%;" }} />
                  <col style={{ width: "100%;" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td style={{ padding: "0.5rem 0;" }}>
                      <strong>Zusammengefasst</strong>
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <strong>
                        <span
                          className="mention-variable"
                          data-variable-id="rentalUnitAdditionalCosts"
                        >
                          $Rental-Unit-RentAdditionalCosts
                        </span>
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </figure>
          </div>
        </div>
        <p style={{ textAlign: "justify" }}>
          Über die Vorauszahlungen für Betriebskosten wird der Vermieter
          jährlich abrechnen. Nach der Abrechnung kann durch Erklärung in
          Textform eine Anpassung der Vorauszahlung auf eine angemessene Höhe
          erfolgen.&nbsp;
        </p>
        <p style={{ textAlign: "justify" }}>
          Soweit nachfolgend nichts anderes festgelegt ist, erfolgt die
          Abrechnung für das Kalenderjahr nach dem Verhältnis der Wohnfläche.
        </p>
        <p style={{ textAlign: "justify" }}>&nbsp;</p>
        <p style={{ textAlign: "justify" }}>
          Berechnungsgrundlage für die Betriebskosten ist das Objekt&nbsp;
          <span className="mention-variable" data-variable-id="objectAddress">
            $Objekt - Address
          </span>
          ,{" "}
          <span className="mention-variable" data-variable-id="objectZip">
            $Objekt - PLZ
          </span>
          &nbsp;
          <span className="mention-variable" data-variable-id="objectCity">
            $Objekt - Stadt
          </span>
          . Bei Vorliegen sachlicher Gründe kann nach billigem Ermessen das
          Objekt als Umlegungsmaßstab durch Erklärung in Textform an den Mieter
          mit Wirkung für den nächsten Abrechnungszeitraum geändert werden.
        </p>
        <p style={{ textAlign: "justify" }}>&nbsp;</p>
        <p style={{ textAlign: "justify" }}>
          Für die folgenden Betriebskosten werden die nachstehenden
          Berechnungsgrundlagen, Abrechnungszeiträume und Umlegungsmaßstäbe
          vereinbart:
        </p>
        <ul>
          <li>
            Kosten für Müllbeseitigung sowie Ungezieferbekämpfung werden
            Hausweise nach Wohn- und Gewerbeeinheiten abgerechnet
          </li>
          <li>
            Kosten der Dachrinnenreinigung und Hausmeister/Hauswart werden nach
            Anzahl der Wohn- und Gewerbeeinheiten abgerechnet
          </li>
          <li>
            Kosten der Rauchmelder für die Wohnung werden nach Anzahl der
            Rauchmelder in der Wohnung abgerechnet
          </li>
          <li>
            Kosten der allgemeinen Rauchmelder werden Hausweise nach Anzahl der
            Wohneinheiten abgerechnet
          </li>
          <li>
            Die monatliche Grundgebühr für den Breitbandkabelanschluss sowie die
            Miet- und Wartungskosten werden nach Anzahl der angeschlossenen
            Wohnungen abgerechnet
          </li>
          <li>
            Wasserverbrauchskosten und Entwässerungsgebühren werden Hausweise
            nach Wohnfläche abgerechnet falls nur ein Zähler für das gesamte
            Objekt vorhanden ist
          </li>
          <li>Messgebühr wird nach besonderer Berechnung erhoben</li>
          <li>
            Wartungskosten werden nach Art und Anzahl der Geräte berechnet
          </li>
        </ul>
        <p>&nbsp;</p>
        <p style={{ textAlign: "justify" }}>
          Bei Vorliegen sachlicher Gründe können nach billigem Ermessen
          Abrechnungszeiträume verkürzt und Umlegungsmaßstäbe durch Erklärung in
          Textform an den Mieter mit Wirkung für den nächsten
          Abrechnungszeitraum geändert werden. Die Änderung des
          Umlegungsmaßstabs gilt nicht für Betriebskosten, die nach Verbrauch
          oder Verursachung erfasst werden, es sei denn, es findet eine Änderung
          der Verbrauchs- oder Verursachungserfassung statt. Die gesetzlichen
          Vorschriften insbesondere der Heizkosten-Verordnung sind einzuhalten.
        </p>
        <p style={{ textAlign: "justify" }}>&nbsp;</p>
        <p style={{ textAlign: "justify" }}>
          Zieht der Mieter vor Ende eines Abrechnungszeitraumes aus, so wird
          auch seine Abrechnung erst mit der nächsten Gesamtabrechnung fällig
          (vgl. § 5 Abs. 4).
        </p>
      </>
      {/* PARAGRAPH 4 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 4 Schönheitsreparaturen</strong>
          </h3>
          <p>
            <ol>
              <li style={{ textAlign: "justify" }}>
                Die Schönheitsreparaturen sind vom Mieter auszuführen, soweit
                sie durch seine Abnutzung bedingt sind.
              </li>
              <li style={{ textAlign: "justify" }}>
                Soweit der Vermieter oder der Mieter Ausgleichsbeträge für
                unterlassene Schönheitsreparaturen vom Vormieter erhalten hat,
                sind diese zur Durchführung von Schönheitsreparaturen in der
                Wohnung zu verwenden bzw. bei Ausführung durch den Mieter an
                diesen auszuzahlen.
              </li>
              <li style={{ textAlign: "justify" }}>
                Schönheitsreparaturen sind fachgerecht auszuführen. Die
                Schönheitsreparaturen umfassen:
                <br />
                das Anstreichen oder Kalken oder Tapezieren der Wände und
                Decken, den Innenanstrich der Fenster, das Streichen der Türen
                und der Außentüren von innen sowie Heizkörper einschließlich der
                Heizrohre und das Reinigen der Teppichböden.
              </li>
            </ol>
          </p>
        </div>
        <ul>
          <li style={{ textAlign: "justify" }}>
            Die Schönheitsreparaturen sind der Regel nach Ablauf folgender
            Zeiträume auszuführen:
            <ul>
              <li style={{ textAlign: "justify" }}>
                In Küchen, Bädern und Duschen{" "}
                <span>
                  alle fünf Jahre,
                  <br />
                  dabei sind die Innenanstriche der Fenster sowie die Anstriche
                  der Türen und der Außentüren von innen, Heizkörper und
                  Heizrohre alle acht Jahre durchzuführen,
                </span>
              </li>
              <li style={{ textAlign: "justify" }}>
                in Wohn- und Schlafräumen, Fluren, Dielen und Toiletten{" "}
                <span>alle acht Jahre,</span>
              </li>
              <li style={{ textAlign: "justify" }}>
                einschließlich der Innenanstriche der Fenster sowie der
                Anstriche der Türen und der Außentüren von innen, Heizkörper und
                Heizrohre
              </li>
              <li style={{ textAlign: "justify" }}>
                in anderen Nebenräumen innerhalb der Wohnung{" "}
                <span>alle zehn Jahre,</span>
                <br />
                einschließlich der Innenanstriche der Fenster sowie der
                Anstriche der Türen und der Außentüren von innen, Heizkörper und
                Heizrohre
              </li>
            </ul>
          </li>
          <li>
            Die Fristen beginnen erstmals mit Beginn der Mietzeit. Der Mieter
            ist für den Umfang der im Laufe der Mietzeit ausgeführten
            Schönheitsreparaturen beweispflichtig.
          </li>
        </ul>
        <ol>
          <li style={{ textAlign: "justify" }}>
            Lässt der Zustand der Wohnung eine Verlängerung der nach Abs. 3
            vereinbarten Fristen zu oder erfordert der Grad der Abnutzung eine
            Verkürzung, so sind nach billigem Ermessen die Fristen des Planes
            bezüglich der Durchführung einzelner Schönheitsreparaturen zu
            verlängern oder zu verkürzen.
          </li>
          <li style={{ textAlign: "justify" }}>
            Hat der Mieter die Schönheitsreparaturen übernommen, so sind die
            nach Abs. 3 und 4 fälligen Schönheitsreparaturen rechtzeitig vor
            Beendigung des Mietverhältnisses nachzuholen.
          </li>
          <li style={{ textAlign: "justify" }}>
            Ist die Wohnung bei Beginn des Mietverhältnisses renoviert übergeben
            worden und sind bei Beendigung des Mietverhältnisses
            Schönheitsreparaturen noch nicht fällig im Sinne von Abs. 3 und 4,
            so hat der Mieter an den Vermieter einen Kostenanteil zu zahlen, da
            die Übernahme der Schönheitsreparaturen durch den Meter bei der
            Berechnung der Miete berücksichtigt worden ist. Zur Berechnung des
            Kostenanteils werden die Kosten einer im Sinne des Abs. 3
            umfassenden und fachgerechten Schönheitsreparatur im Zeitpunkt der
            Beendigung des Mietverhältnisses ermittelt.&nbsp;
            <br />
            Der zu zahlende Anteil entspricht, soweit nach Abs. 4 nichts anderes
            gilt, dem Verhältnis zwischen den vollen Fristen lt. Abs. 3 und den
            seit Ausführung der letzten Schönheitsreparaturen bis zur Beendigung
            des Mietverhältnisses abgelaufenen Zeiträumen. Soweit nach Abs. 4
            die Fristen wegen des Zustandes der Wohnung oder des
            Abnutzungsgrades zu verlängern oder zu verkürzen sind, so sind an
            Stelle der vollen Fristen laut Abs. 3 die gemäß Abs. 4 angepassten
            Fristen für die Berechnung des Verhältnisses maßgebend.
            <br />
            Die Kostenanteile des Mieters werden zur Durchführung von
            Schönheitsreparaturen verwendet (vgl. Abs. 2). Soweit der Mieter
            noch nicht fällige Schönheitsreparaturen rechtzeitig vor Beendigung
            des Mietverhältnisses durchführt, ist er von der Zahlung des
            Kostenanteils befreit.
          </li>
        </ol>
      </>
      {/* PARAGRAPH 5 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 5 Kleinreparaturen</strong>
          </h3>
          <p>
            Der Mieter hat die Kosten für die im Mietobjekt anfallenden
            Kleinreparaturen zu tragen. Kleinreparaturen sind die Instandsetzung
            von kleineren Schäden an Installationsgegenständen für Elektrizität,
            Gas und Wasser, Heiz- und Kocheinrichtungen, Fenster und
            Türverschlüssen sowie Verschlussvorrichtungen für Fensterläden. Der
            Mieter trägt die Kosten der Kleinreparaturen bis zu einer Höhe von
            100 Euro pro Einzelfall. Fallen im Laufe eines Mietjahres mehrere
            Kleinreparaturen an, sind die vom Mieter zu tragenden Kosten auf
            insgesamt 250 Euro, höchstens jedoch auf 8% der Jahresgrundmiete
            begrenzt.
          </p>
        </div>
      </>
      {/* PARAGRAPH 6 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 6 Weitere Leistungen des Mieters</strong>
          </h3>
          <p>
            Vom Mieter sind folgende Leistungen zu erbringen, weil die Miete
            diese Leistungen nicht deckt:
          </p>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Die Reinigung des Treppenhauses und der Gemeinschaftsflächen
              obliegt den Mietern nach einem vom Vermieter nach billigem
              Ermessen aufzustellenden Reinigungsplan. Der Vermieter behält sich
              vor, die Treppenhausreinigung durch Erklärung gegenüber den
              Mietern in Textform zu übernehmen, wenn dies aus Gründen der
              besseren Bewirtschaftung nach billigem Ermessen geboten ist, und
              die Kosten hierfür als Betriebskosten umzulegen.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Die Schneebeseitigung und das Streuen bei Glatteis obliegen den
              Mietern nach einem vom Vermieter nach billigem Ermessen
              auszustellenden Schneebeseitigungsplan. Der Vermieter behält sich
              vor, die Schneebeseitigung durch Erklärung gegenüber den Mietern
              in Textform zu übernehmen, wenn dies aus Gründen der besseren
              Bewirtschaftung nach billigem Ermessen geboten ist, und die Kosten
              hierfür als Betriebskosten umzulegen.
            </li>
          </ol>
        </div>
      </>
      {/* PARAGRAPH 7 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 7 Mietdauer und Kündigung</strong>
          </h3>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Das Mietverhältnis wird für unbestimmte Zeit abgeschlossen.
            </li>
            <li style={{ textAlign: "justify" }}>
              Der Vertrag kann vom Mieter bis zum dritten Werktag eines
              Kalendermonats für den Ablauf des übernächsten Kalendermonats
              schriftlich gekündigt werden. Die fristlose Kündigung richtet sich
              nach den gesetzlichen Vorschriften.
            </li>
            <li style={{ textAlign: "justify" }}>
              Der Vermieter wird von sich aus dem Mietverhältnis grundsätzlich
              nicht auflösen. Es kann jedoch in besonderen Ausnahmefällen das
              Mietverhältnis schriftlich unter Einhaltung der gesetzlichen
              Fristen kündigen, wenn wichtige berechtigte Interessen des
              Vermieters eine Beendigung des Mietverhältnisses notwendig machen.
            </li>
            <li style={{ textAlign: "justify" }}>
              Bei Vorliegen eines wichtigen Grundes kann der Vermieter nach der
              gesetzlichen Regelung außerordentlich fristlos kündigen. Ein
              wichtiger Grund liegt vor, wenn dem Vermieter unter
              Berücksichtigung aller Umstände des Einzelfalls, insbesondere ein
              Verschulden des Mieters, und unter Abwägung der beiderseitigen
              Interessen die Fortsetzung des Mietverhältnisses bis zum Ablauf
              der Kündigungsfrist oder bis zur sonstigen Beendigung des
              Mietverhältnisses nicht zugemutet werden kann.
            </li>
          </ol>
          <p style={{ textAlign: "justify" }}>
            Ein wichtiger Grund liegt insbesondere vor, wenn
          </p>
        </div>
        <ol>
          <li style={{ textAlign: "justify" }}>
            der Mieter oder derjenige, welchem der Mieter den Gebrauch der
            Mietsache überlassen hat, die Rechte des Vermieters dadurch in
            erheblichen Maßen verletzt, dass er die Mietsache durch
            Vernachlässigung der ihm obliegenden Sorgfalt erheblich gefährdet
            oder sie unbefugt einem Dritten überlässt oder
          </li>
          <li style={{ textAlign: "justify" }}>
            der Mieter den Hausfrieden nachhaltig stört, sodass dem Vermieter
            unter Berücksichtigung aller Umstände des Einzelfalles, insbesondere
            ein Verschulden des Mieters, und unter Abwägung der beiderseitigen
            Interessen die Fortsetzung des Mietverhältnisses bis zum Ablauf der
            Kündigungsfrist oder bis zur sonstigen Beendigung des
            Mietverhältnisses nicht zugemutet werden kann oder
          </li>
          <li style={{ textAlign: "justify" }}>
            der Mieter für zwei aufeinanderfolgende Termine mit der Entrichtung
            der Miete oder eines Teils der Miete, der eine Monatsmiete
            übersteigt, in Verzug ist oder
          </li>
          <li style={{ textAlign: "justify" }}>
            in einem Zeitraum, der sich über mehr als zwei Termine erstreckt,
            mit der Entrichtung der Miete in Höhe eines Betrages in Verzug ist,
            der die Miete für zwei Monate erreicht.
          </li>
        </ol>
      </>
      {/* PARAGRAPH 8 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>
              § 8 Keine stillschweigende Verlängerung des Mietverhältnisses
            </strong>
          </h3>
          <p style={{ textAlign: "justify" }}>
            Der Vermieter ist nicht damit einverstanden, dass eine Verlängerung
            des Mietverhältnisses eintritt, wenn der Mieter nach Ablauf der
            Vertragszeit oder einer gewährten Räumungsfrist die Wohnung
            weiterhin benutzt; d.h. § 545 BGB wird ausgeschlossen.
          </p>
        </div>
      </>
      {/* PARAGRAPH 9 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>
              § 9 Benutzung der Mietsache, Änderungsrecht des Vermieters
            </strong>
          </h3>
          <p style={{ textAlign: "justify" }}>
            Die Hausordnung und die Benutzungsordnungen darf der Vermieter
            nachträglich aufstellen oder ändern, soweit dies im Interesse einer
            ordnungsgemäßen Bewirtschaftung des Hauses dringend notwendig und
            für den Mieter zumutbar ist. Etwaige neue oder geänderte Regelungen
            werden dem Mieter besonders mitgeteilt. Darüberhinausgehende
            Regelungen bedürfen der Zustimmung des Mieters.
          </p>
        </div>
      </>
      {/* PARAGRAPH 10 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 10 Erhaltung der Mietsache</strong>
          </h3>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Der Mieter hat die Mietsache sowie die zur gemeinschaftlichen
              Benutzung bestimmte Räume, Einrichtungen und Anlagen schonend und
              pfleglich zu behandeln. Er hat insbesondere auch zur Vermeidung
              von Feuchtigkeits- und Frostschäden für ausreichende Lüftung und
              Heizung aller ihm überlassenen Räume zu sorgen.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Schäden in den Mieträumen, im Hause und an den Außenanlagen sind
              dem Vermieter unverzüglich anzuzeigen. Der Mieter haftet für
              Schäden, die durch schuldhafte Verletzung der ihm obliegenden
              Anzeige- und Sorgfaltspflichten verursacht werden, insbesondere
              wenn technische Anlagen und sonstige Einrichtungen unsachgemäß
              behandelt, die überlassenen Räume nur unzureichend gelüftet,
              geheizt oder nicht genügend gegen Frost geschützt werden. Er
              haftet auch für Schäden, die durch seine Angehörigen, Untermieter
              sowie von sonstigen Personen schuldhaft verursacht werden, die auf
              Veranlassung des Mieters mit der Mietsache in Berührung
              kommen.&nbsp;
            </li>
          </ol>
        </div>
      </>
      {/* PARAGRAPH 11 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 11 Modernisierung und Energieeinsparung</strong>
          </h3>
          <p style={{ textAlign: "justify" }}>
            Maßnahmen zur Erhaltung der Mietsache und Modernisierungsmaßnahmen
            gem. § 555b BGB hat der Mieter zu dulden, soweit sich die
            Verpflichtung dazu aus § 555a oder § 555d BGB ergibt. Bei einer
            Mieterhöhung wegen Modernisierung sind die §§ 559 bis 559b BGB zu
            beachten.
          </p>
        </div>
      </>
      {/* PARAGRAPH 12 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 12 Zustimmungspflichtige Handlungen des Mieters</strong>
          </h3>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Mit Rücksicht auf die Gesamtheit der Mieter und im Interesse einer
              ordnungsgemäßen Bewirtschaftung des Gebäudes, des Grundstücks und
              der Wohnung bedarf der Mieter der vorherigen Zustimmung des
              Wohnungsunternehmens, wenn er&nbsp;
              <ol>
                <li style={{ textAlign: "justify" }}>
                  die Wohnung oder einzelne Räume entgeltlich oder unentgeltlich
                  Dritten überlässt, es sei denn, es handelt sich um eine
                  unentgeltliche Aufnahme von angemessener Dauer (Besuch),
                </li>
                <li style={{ textAlign: "justify" }}>
                  die Wohnung oder einzelne Räume zu anderen als Wohnzwecken
                  benutzt oder benutzen lässt,
                </li>
                <li style={{ textAlign: "justify" }}>
                  Schilder (ausgenommen übliche Namenschilder an den dafür
                  vorgesehenen Stellen), Aufschriften oder Gegenstände jeglicher
                  Art in gemeinschaftlichen Räumen, am Gebäude anbringt oder auf
                  dem Grundstück aufstellt,
                </li>
                <li style={{ textAlign: "justify" }}>
                  Tiere hält, soweit es sich nicht um übliche Kleintierhaltung
                  handelt (z. B. Fische, Hamster, Vögel), es sei denn, in § 16
                  ist etwas anderes vereinbart,
                </li>
                <li style={{ textAlign: "justify" }}>
                  Antennen außerhalb der geschlossenen Mieträume aufstellt,
                  anbringt oder verändert,
                </li>
                <li style={{ textAlign: "justify" }}>
                  von dem lauten Übergabeprotokoll vereinbarten Beheizungsart
                  abweicht,
                </li>
                <li style={{ textAlign: "justify" }}>
                  in den Mieträumen, im Gebäude oder auf dem Grundstück
                  außerhalb vorgesehener Park-, Einstell- oder Abstellplätze ein
                  Kraftfahrzeug einschließlich Moped oder Mofa abstellen will,
                </li>
                <li style={{ textAlign: "justify" }}>
                  Um-, An- und Einbauten sowie Installationen vornimmt, die
                  Mieträume, Anlagen oder Einrichtungen verändert; dies gilt
                  auch, soweit die Maßnahmen für die behindertengerechte Nutzung
                  der Mietsache oder den Zugang zu ihr erforderlich sind,
                </li>
                <li style={{ textAlign: "justify" }}>
                  Heizöl oder andere feuergefährliche Stoffe lagern will,
                </li>
                <li style={{ textAlign: "justify" }}>
                  Weitere Schlüssel anfertigen lassen will.
                  <br />
                  &nbsp;
                </li>
              </ol>
            </li>

            <li style={{ textAlign: "justify" }}>
              Die Zustimmung des Vermieters soll schriftlich erfolgen; dies
              schließt nicht aus, dass die Vertragsparteien im Einzelfall eine
              mündliche Vereinbarung treffen. Die Zustimmung kann unter Auflagen
              erfolgen.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Für die Fälle der Überlassung der Wohnung oder einzelner Räume
              nach Abs. 1 a) gelten die Bestimmungen des § 553 BGB.
              <br />
              Bei Maßnahmen, die für die behindertengerechte Nutzung
              erforderlich sind, gelten die Bestimmungen des § 554 a BGB.
              <br />
              <br />
              Der Vermieter erteilt in den übrigen Fällen des Abs. 1 die
              Zustimmung, wenn die Handlung dem üblichen Mietgebrauch entspricht
              und keine berechtigten Interessen des Vermieters entgegenstehen
              und Belästigungen anderer Hausbewohner und Nachbarn sowie
              Beeinträchtigungen der Mietsache und des Grundstücks nicht zu
              erwarten sind.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Der Vermieter kann eine erteilte Zustimmung widerrufen, wenn
              Auflagen nicht eingehalten, Bewohner, Gebäude oder Grundstücke
              gefährdet oder beeinträchtigt oder Nachbarn belästigt werden oder
              sich Umstände ergeben, unter denen eine Zustimmung nicht mehr
              erteilt werden würde.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Durch die Zustimmung des Vermieters wird eine etwaige Haftung des
              Mieters nicht ausgeschlossen.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Für Aufstellung und Betrieb von haushaltsüblichen Waschmaschinen,
              Trockenautomaten und Geschirrspülmaschinen bedarf der Mieter
              keiner vorherigen Zustimmung des Vermieters. Der Mieter hat dabei
              jedoch die einschlägigen technischen Vorschriften und die
              verkehrsüblichen Regeln zu beachten, um die mit der Aufstellung
              und Betrieb derartiger Geräte verbundenen Beeinträchtigungen und
              Schäden zu verhindern.
              <br />
              Vor Aufstellung hat der Mieter dem Vermieter seine Absicht
              anzuzeigen, damit eventuelle Gefahren für die Mietsache etc.
              abgeklärt werden können.
            </li>
          </ol>
        </div>
      </>
      {/* PARAGRAPH 13 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 13 Besichtigung der Mietsache durch den Vermieter</strong>
          </h3>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Beauftragte des Vermieters können in begründeten Fällen die
              Mietsache nach rechtzeitiger Ankündigung bei dem Mieter zu
              angemessener Tageszeit besichtigen oder besichtigen lassen.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              In dringenden Fällen (z. B. Rohrbruch oder Frostgefahr) ist der
              Vermieter bei Abwesenheit des Mieters berechtigt, die Mieträume
              auf Kosten des Mieters öffnen zu lassen, sofern die Schlüssel dem
              Vermieter nicht zur Verfügung stehen. Der Mieter ist unverzüglich
              zu benachrichtigen.
            </li>
          </ol>
        </div>
      </>
      {/* PARAGRAPH 14 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>
              § 14 Fortsetzung des Mietverhältnisses bei Tod des Mieters
            </strong>
          </h3>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Ist das Mietverhältnis mit mehreren Mietern abgeschlossen, so wird
              es nach dem Tod eines der Mieter mit den überlebenden Mietern
              fortgesetzt. Diese können das Mieterverhältnis innerhalb eines
              Monats, nachdem sie vom Tod des Mieters Kenntnis erlangt haben,
              außerordentlich mit der gesetzlichen Frist kündigen.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Führt der Mieter mit seinem Ehegatten einen gemeinsamen Haushalt
              in der Wohnung, so tritt mit dem Tode des Mieters der Ehegatte in
              das Mietverhältnis ein. Dasselbe gilt für den Lebenspartner.
              Erklärt der Ehegatte oder Lebenspartner binnen eines Monats,
              nachdem er vom Tode des Mieters Kenntnis erlangt hat, dem
              Vermieter gegenüber, dass er das Mietverhältnis nicht fortsetzen
              will, so gilt sein Eintritt in das Mietverhältnis als nicht
              erfolgt.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Im Übrigen gelten im Falle des Todes des Mieters die gesetzlichen
              Bestimmungen.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Der Vermieter kann, falls der verstorbene Mieter keine
              Mietsicherheit geleistet hat, von den Personen, die in das
              Mietverhältnis eingetreten sind oder mit denen es fortgesetzt
              wird, nach Maßgabe der gesetzlichen Regelung eine
              Sicherheitsleistung verlangen.
            </li>
          </ol>
        </div>
      </>
      {/* PARAGRAPH 15 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 15 Rückgabe der Mietsache</strong>
          </h3>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Bei Beendigung des Mietverhältnisses sind die überlassenen Räume
              in ordnungsgemäßem Zustand zu übergeben.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Hat der Mieter Änderungen der Mietsache vorgenommen, so hat er den
              ursprünglichen Zustand spätestens bis zur Beendigung des
              Mietverhältnisses wiederherzustellen, soweit nichts anderes
              vereinbart ist oder wird. Für Anlagen und Einrichtungen (auch
              Schilder und Aufschriften) innerhalb und außerhalb der Mieträume
              gilt das Gleiche. Der Vermieter kann verlangen, dass Einrichtungen
              beim Auszug zurückbleiben, wenn er den Mieter angemessen
              entschädigt. Dem Vermieter steht dieses Recht nicht zu, wenn der
              Mieter an der Mitnahme ein berechtigtes Interesse hat.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Bei Auszug hat der Mieter alle Schlüssel an den Vermieter zu
              übergeben; anderenfalls ist der Vermieter berechtigt, auf Kosten
              des Mieters die Räume öffnen und neue Schlösser und Schlüssel
              anfertigen zu lassen, es sei denn, der Mieter macht glaubhaft,
              dass ein Missbrauch ausgeschlossen ist.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Die Verjährungsfrist für Ersatzansprühe des Vermieters wird
              abweichend von § 548 BGB auf ein Jahr nach Rückgabe der Mietsache
              verlängert.
            </li>
          </ol>
        </div>
      </>
      {/* PARAGRAPH 16 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 16 Mehrere Mieter, Gesamtschuld, Vollmacht</strong>
          </h3>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Mehrere Mieter haften für alle Verpflichtungen aus dem Mietvertrag
              als Gesamtschuldner.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Willenserklärungen sind gegenüber allen Mietern abzugeben; für die
              Rechtswirksamkeit des Zugangs genügt es, wenn sie gegenüber einem
              der Mieter abgegeben werden. Diese Empfangsvollmacht, die auch für
              die Entgegennahme von Kündigungen gilt, kann aus berechtigtem
              Interesse widerrufen werden.
            </li>
          </ol>
        </div>
      </>
      {/* PARAGRAPH 17 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 17 Vertragsbestandteile</strong>
          </h3>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Das Übergabeprotokoll wird bei der Wohnungsübergabe aufgenommen,
              unterschrieben und ausgehändigt.
              <br />
              &nbsp;
            </li>
            <li style={{ textAlign: "justify" }}>
              Auch folgende Unterlagen sind Bestandteile des Mietvertrages:
              <ul>
                <li style={{ textAlign: "justify" }}>die Hausordnung</li>
                <li style={{ textAlign: "justify" }}>
                  die Kautionsvereinbarung
                </li>
                <li style={{ textAlign: "justify" }}>Personalausweis</li>
                <li style={{ textAlign: "justify" }}>Mieterselbstauskunft</li>
              </ul>
            </li>
          </ol>
        </div>
      </>
      {/* PARAGRAPH 18 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 18 Energieausweis</strong>
          </h3>
          <p style={{ textAlign: "justify" }}>
            Aufgrund der Verpflichtung nach § 16 der Energieeinsparverordnung
            wurde dem Mieter bei Gelegenheit des Abschlusses dieses Vertrages
            ein Energieausweis zur Information zugänglich gemacht. Der Inhalt
            des Ausweises ist ausdrücklich nicht zwischen den Vertragsparteien
            vereinbart. Er war auch nicht Gegenstand der Vertragsanbahnung. Die
            Vertragsparteien sind sich einig, dass der Energieausweis keine
            Rechtswirkungen für diesen Vertrag haben soll und sich daraus
            insbesondere keine Gewährleistungs- und Modernisierungsansprüche
            herleiten lassen.
          </p>
        </div>
      </>
      {/* PARAGRAPH 19 ##################################################################################### */}
      <>
        <div style={{ breakInside: "avoid" }}>
          <h3 style={{ textAlign: "center" }}>
            <strong>§ 19 Schlussbestimmungen</strong>
          </h3>
          <ol>
            <li style={{ textAlign: "justify" }}>
              Änderungen und Ergänzungen dieses Vertrages sind schriftlich zu
              vereinbaren; dies schließt nicht aus, dass die Vertragsparteien im
              Einzelfall mündliche Vereinbarungen treffen.
            </li>
            <li style={{ textAlign: "justify" }}>
              Für Streitigkeiten aus diesem Vertrag ist das Gericht zuständig,
              in dessen Bezirk die Wohnung liegt.
            </li>
          </ol>
        </div>
      </>
    </div>
  );
};

export default VacancyContract;
